import ArrowDown from './ArrowDown';
import ArrowUp from './ArrowUp';
import ArrowRight from './ArrowRight';
import ChevronDown from './ChevronDown';
import ChevronLeft from './ChevronLeft';
import ChevronRight from './ChevronRight';
import Close from './Close';
import ColorPalette from './ColorPalette';
import Droplet from './Droplet';
import Edit from './Edit';
import ExpandArrowsAlt from './ExpandArrowsAlt';
import Filter from './Filter';
import Image from './Image';
import Layout from './Layout';
import Loading from './Loading';
import Lock from './Lock';
import MetroShrink from './MetroShrink';
import Redo from './Redo';
import Resize from './Resize';
import Ruler from './Ruler';
import Search from './Search';
import SortAlphaDown from './SortAlphaDown';
import SortAlphaUp from './SortAlphaUp';
import Tag from './Tag';
import ToggleOn from './ToggleOn';
import ToggleOff from './ToggleOff';
import Undo from './Undo';
import Upload from './Upload';
import Public from './Public';
import Add from './Add';
import Print from './Print';
import Star from './Star';
import StarSolid from './StarSolid';
import Bars from './Bars';
import Xmark from './Xmark';
import GalleryThumbnails from './GalleryThumbnails';
import Backpack from './Backpack';
import Book from './Book';
import Check from './Check';
import ExclamationMark from './ExclamationMark';
import Info from './Info';
import Warning from './Warning';
import Gear from './Gear';
import ShareNodes from './ShareNodes';
import CameraViewFinder from './CameraViewFinder';
import Eye from './Eye';
import Document from './Document';
import Video from './Video';
import FullScreen from './FullScreen';
import Expand from './Expand';
import Chat from './Chat';

const collection = {
  ArrowDown,
  ArrowUp,
  ArrowRight,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Close,
  ColorPalette,
  Droplet,
  Edit,
  ExpandArrowsAlt,
  Filter,
  Image,
  Layout,
  Loading,
  Lock,
  MetroShrink,
  Redo,
  Resize,
  Ruler,
  Search,
  SortAlphaDown,
  SortAlphaUp,
  Tag,
  ToggleOn,
  ToggleOff,
  Undo,
  Upload,
  Public,
  Add,
  Print,
  Star,
  StarSolid,
  Bars,
  Xmark,
  Check,
  ExclamationMark,
  Info,
  Warning,
  Gear,
  ShareNodes,
  CameraViewFinder,
  Book,
  Backpack,
  GalleryThumbnails,
  Eye,
  Document,
  Video,
  FullScreen,
  Expand,
  Chat,
};

export default collection;
